export function displayAlertMessage(type, message) {
    var divElement = document.createElement('div');
    divElement.className = type;
    divElement.role = "alert";
    divElement.innerHTML = message;
    document.getElementById("alertMessage").appendChild(divElement);
}
